import { ThemeOptions } from '@mui/material';

import { capitalCategoricalPalette } from '../../capitalCategoricalPalette';

export const MuiGauge: NonNullable<ThemeOptions['components']>['MuiGauge'] = {
  styleOverrides: {
    valueArc: {
      fill: capitalCategoricalPalette[0]
    }
  }
};

